/* PDP gallery — per-image pairing and the sticky info column.

   Desktop only by default. The mobile gallery is left exactly as Shapes
   ships it unless the merchant opts in, because the mobile slide markup
   carries conditional hide classes that behave differently from desktop.

   Layout is CSS. This file does three things CSS cannot:
     1. mark which slides render half width
     2. identify the product info column so it can stick
     3. clear overflow:hidden from ancestors, which otherwise silently
        disables position:sticky no matter what else is set */
(function () {
  if (window.__pdpGalleryInit) return;
  window.__pdpGalleryInit = true;

  var cfg = window.__pdpGallery || {};

  function isDesktop() {
    return window.matchMedia('(min-width: 1024px)').matches;
  }

  function active() {
    return isDesktop() || cfg.applyOnMobile;
  }

  function applyPairs() {
    var list = document.querySelector('.splide--product .splide__list');
    if (!list) return false;
    var slides = list.querySelectorAll('.splide__slide');
    if (!slides.length) return false;

    var pairs = cfg.pairs;
    if (!pairs || !pairs.length) return true;

    for (var i = 0; i < pairs.length; i++) {
      var pos = parseInt(pairs[i], 10);
      if (!pos) continue;
      var slide = slides[pos - 1];
      if (slide) slide.classList.add('pdp-pair');
    }
    return true;
  }

  /* Sticky fails silently if any ancestor clips overflow. Walk up from the
     info column and open any that do. Desktop only — mobile relies on that
     clipping for its own gallery. */
  function clearClipping(from) {
    if (!isDesktop()) return;
    var el = from.parentElement;
    for (var i = 0; i < 12 && el && el !== document.body; i++) {
      var s = window.getComputedStyle(el);
      if (s.overflow !== 'visible' || s.overflowX !== 'visible' || s.overflowY !== 'visible') {
        el.style.setProperty('overflow', 'visible', 'important');
        el.style.setProperty('overflow-x', 'visible', 'important');
        el.style.setProperty('overflow-y', 'visible', 'important');
      }
      el = el.parentElement;
    }
  }

  function applySticky() {
    if (!cfg.sticky || !isDesktop()) return true;
    var existing = document.querySelector('.pdp-sticky-info');
    if (existing) { clearClipping(existing); return true; }

    var media = document.querySelector('.splide--product');
    var title = document.querySelector('h1');
    if (!media || !title) return false;

    var el = title;
    for (var i = 0; i < 12 && el && el !== document.body; i++) {
      var parent = el.parentElement;
      if (!parent) break;
      if (parent.contains(media) && !el.contains(media)) {
        el.classList.add('pdp-sticky-info');
        clearClipping(el);
        return true;
      }
      el = parent;
    }
    return false;
  }

  function run() {
    if (!active()) return true;
    var a = applyPairs();
    var b = applySticky();
    return a && b;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  var tries = 0;
  var timer = setInterval(function () {
    tries++;
    if (run() || tries > 24) clearInterval(timer);
  }, 250);

  window.addEventListener('load', run);
})();
